class VideoSwitcher extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');

    if (this.video && this.video.querySelectorAll('source').length > 1) {
      this.bindVideoSwitcher();
    }
  }

  bindVideoSwitcher() {
    const mediaQueryList = window.matchMedia('(max-width: 767px)');

    function handleViewportChange(mql) {
      this.video.load();
      requestAnimationFrame(() => {
        this.video.play();
      });
    }

    handleViewportChange.bind(this)(mediaQueryList);

    mediaQueryList.addEventListener('change', handleViewportChange.bind(this));
  }
}

customElements.define('video-switcher', VideoSwitcher);
